<template>
	<div>
		<VIcono
			v-if="medio === 'correoElectrónico'"
			identificador="mail"
			:tamaño="tamaño"
		></VIcono>
		<VIcono
			v-else-if="medio === 'númeroTelefónico'"
			identificador="phone"
			:tamaño="tamaño"
		></VIcono>
		<figure v-else-if="medio">
			<img
				:src="`/img/${medio}_logo.png`"
				:alt="medio"
				:width="tamaño"
			>
		</figure>
	</div>
</template>

<script>

import VIcono from '@/components/base/VIcono.vue'

export default {
	name: 'VContactoBoton',

	components: {
		VIcono
	},

	props: {
		medio: {
			type: String,
			required: true
		},
		tamaño: {
			type: String
		}
	},

}

</script>
